function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 800",
    style: {
      enableBackground: "new 0 0 1200 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.3748,
    y1: -52.1819,
    x2: 764.3552,
    y2: 902.9432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_1_)"
    },
    d: "M1122.101,187.009c-28.291-55.733-90.41-97.644-150.872-84.786 c-36.202,7.7-72.184,33.529-106.896,20.562c-25.02-9.346-39.142-35.851-60.173-52.481c-32.37-25.597-78.317-25.299-117.766-13.83 c-39.449,11.468-75.561,32.558-114.534,45.596c-66.421,22.22-140.554,19.808-205.437-6.685 c-28.482-11.63-55.143-27.681-84.139-37.921c-28.996-10.24-61.883-14.216-89.871-1.41c-27.989,12.806-48.073,46.3-38.359,75.857 c1.937,5.894,4.975,11.701,4.578,17.9c-0.636,9.941-10.099,17.223-19.67,19.434c-9.571,2.211-19.546,0.767-29.36,1.02 c-44.037,1.133-83.391,41.904-83.6,86.609c-0.173,37.072,22.357,69.649,41.618,101.15c19.261,31.5,36.572,69.298,25.098,104.494 c-6.804,20.871-22.764,37.198-33.221,56.45C32.387,568.88,46.878,634.954,84.731,677.054c37.853,42.1,94.543,62.7,150.493,67.604 c55.95,4.904,112.061-4.302,167.499-13.402c55.438-9.1,111.593-18.151,167.515-12.937l-3.006-1.657 c109.254,27.393,223.539,33.969,335.144,19.287c23.364-3.074,50.186-9.683,60.061-31.392c8.337-18.328,0.851-39.812,2.567-59.923 c2.473-28.982,23.903-52.723,47.269-69.574c23.366-16.85,49.875-29.391,70.927-49.135c41.183-38.624,55.158-98.407,61.298-154.974 C1151.264,308.635,1150.391,242.742,1122.101,187.009z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024701187657239549810000006400655190246921657_",
    gradientUnits: "userSpaceOnUse",
    x1: -2965.2839,
    y1: 602.3297,
    x2: -3002.4302,
    y2: 453.7448,
    gradientTransform: "matrix(-1 0 0 1 -1958.584 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024701187657239549810000006400655190246921657_)"
    },
    d: "M989.083,728.837 c26.254,5.249,59.78-23.373,70.581-54.643c11.115-32.179-9.264-45.66-9.107-90.313c0.179-50.725,26.565-58.369,44.018-126.742 c3.938-15.426,26.726-104.697-1.518-121.43c-26.114-15.471-99.466,28.93-112.322,85.76c-9.167,40.522,19.172,57.536,8.348,104.733 c-9.497,41.412-34.456,42.011-44.018,81.965C933.423,656.807,954.612,721.945,989.083,728.837z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062192932062144152900000010940634549227012486_",
    gradientUnits: "userSpaceOnUse",
    x1: 5294.4893,
    y1: 421.7728,
    x2: 5229.0591,
    y2: 739.1987,
    gradientTransform: "matrix(1 0 0 1 -4247.4199 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062192932062144152900000010940634549227012486_)"
    },
    d: "M990.99,741.126 c-7.077-54.652,6.729-138.966,19.558-200.075c13.889-66.16,29.652-120.125,29.81-120.662l2.185,0.641 c-0.158,0.537-15.9,54.43-29.77,120.505c-12.791,60.93-26.56,144.966-19.524,199.299L990.99,741.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055678899207365482840000001700947165230109618_",
    gradientUnits: "userSpaceOnUse",
    x1: 5418.0278,
    y1: 457.6385,
    x2: 5146.0278,
    y2: 935.8797,
    gradientTransform: "matrix(1 0 0 1 -4247.4199 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055678899207365482840000001700947165230109618_)"
    },
    d: "M1019.319,722.735 c-34.438-17.944-46.226-79.56-26.65-99.586c13.227-13.531,32.195,0.701,50.494-13.325c23.364-17.908,6.177-51.636,24.546-95.378 c15.632-37.225,53.129-72.449,75.04-65.222c22.937,7.565,35.017,63.699,15.429,97.482c-12.739,21.969-32.238,23.048-36.468,43.481 c-4.908,23.709,18.806,34.522,18.935,57.507C1140.878,688.985,1064.877,746.474,1019.319,722.735z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056388385509947369890000008369350227667340679_",
    gradientUnits: "userSpaceOnUse",
    x1: 5337.479,
    y1: 529.4527,
    x2: 5294.0103,
    y2: 740.3354,
    gradientTransform: "matrix(1 0 0 1 -4247.4199 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056388385509947369890000008369350227667340679_)"
    },
    d: "M1037.902,738.515 c-0.206,0-0.414-0.045-0.611-0.141c-0.697-0.338-0.988-1.177-0.65-1.874c45.655-94.078,59.043-203.216,59.173-204.307 c0.092-0.77,0.79-1.319,1.559-1.227c0.769,0.091,1.319,0.789,1.227,1.558c-0.131,1.096-13.576,110.703-59.435,205.201 C1038.923,738.224,1038.423,738.515,1037.902,738.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M1131.571,560.456c-0.144,0-0.289-0.046-0.412-0.141c-0.292-0.228-0.344-0.649-0.117-0.941 c14.411-18.498,30.383-46.288,24.633-73.636c-3.424-16.287-13.062-24.782-13.159-24.866c-0.28-0.242-0.311-0.665-0.068-0.945 c0.243-0.28,0.666-0.311,0.946-0.068c0.41,0.354,10.077,8.878,13.594,25.604c3.232,15.372,1.537,40.817-24.887,74.735 C1131.968,560.367,1131.77,560.456,1131.571,560.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M1016.214,714.52c-0.214,0-0.424-0.102-0.554-0.291c-22.147-32.322-29.699-57.297-22.447-74.229 c6.448-15.055,22.728-17.856,22.892-17.883c0.366-0.057,0.709,0.189,0.769,0.555c0.059,0.365-0.189,0.71-0.554,0.769 c-0.156,0.025-15.734,2.726-21.882,17.104c-7.048,16.484,0.464,41.02,22.327,72.927c0.209,0.306,0.131,0.723-0.174,0.932 C1016.476,714.482,1016.344,714.52,1016.214,714.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142158688383794878110000010162768813567256448_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2883,
    y1: 1094.8634,
    x2: 418.1462,
    y2: 177.4144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142158688383794878110000010162768813567256448_)"
    },
    d: "M424.313,745.833 c0,0,70.953-97.193,59.419-189.073c-11.534-91.88-69.113-80.92-94.733-26.588c-25.621,54.332-48.653,46.874-33.431-4.206 c15.221-51.08,34.299-84.327,2.758-135.175c-31.542-50.848-34.812-72.453-17.09-117.825 c17.722-45.372,39.977-109.66-30.541-132.599c-70.518-22.939-140.767,47.537-124.322,139.774 c16.445,92.237,26.322,102.284,3.673,136.451c-22.65,34.167-13.211,48.2-10.002,70.438c3.21,22.239-31.394,27.445-30.657-3.878 c0.737-31.324,44.754-105.254,14.711-139.745c-30.043-34.491-88.929-34.863-104.009,44.887 c-15.08,79.751,33.238,115.591,30.832,144.435c-2.405,28.844-28.355-14.893-50.958,14.511 c-22.603,29.404,7.829,52.5,30.224,68.434c22.395,15.933,56.163,44.492,24.031,65.23c-32.132,20.738-62.555,0.892-42.871,64.928 H424.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M278.446,206.88c-2.316,1.341-4.347,3.021-6.327,4.824 c-1.972,1.806-3.791,3.81-5.483,5.938c-3.418,4.233-6.304,9-8.654,14.069c-4.714,10.155-7.236,21.459-8.075,32.773 c-0.148,1.417-0.191,2.834-0.254,4.253c-0.048,1.419-0.128,2.842-0.096,4.258l0.021,4.258l0.189,4.244l0.105,2.123l0.19,2.11 l0.388,4.224c0.389,2.785,0.661,5.609,1.154,8.373c0.468,2.771,0.929,5.55,1.543,8.28l0.867,4.115l0.9,3.978l3.624,15.88 c4.797,21.164,9.42,42.319,13.053,63.585c3.534,21.252,5.98,42.737,5.429,63.964c-0.127,5.301-0.45,10.581-1.077,15.792 c-0.603,5.214-1.437,10.383-2.66,15.411c-1.207,5.031-2.693,9.965-4.588,14.686c-2.105,5.343-3.748,10.886-5.034,16.378 c-2.425,11.028-3.857,22.057-4.951,33.04c-1.06,10.987-1.884,21.933-2.538,32.862c-1.377,21.84-2.557,43.612-5.446,65.083 c-0.365,2.683-0.751,5.361-1.214,8.019c-0.407,2.676-0.937,5.314-1.44,7.964c-0.465,2.663-1.134,5.258-1.692,7.897 c-0.316,1.305-0.674,2.595-1.01,3.895c-0.344,1.296-0.661,2.607-1.081,3.872l-1.19,3.833c-0.399,1.278-0.902,2.504-1.349,3.762 c-0.861,2.536-1.991,4.922-3.023,7.379c-2.303,4.76-5.006,9.301-8.304,13.355l0.805,0.867c3.658-3.856,6.771-8.296,9.487-13.008 c2.59-4.783,4.85-9.791,6.684-14.967c3.78-10.322,6.266-21.099,8.307-31.905c4.077-21.648,6.011-43.573,8.21-65.299 c1.118-10.864,2.108-21.711,3.478-32.443c1.358-10.723,3.056-21.354,5.589-31.536c1.338-5.067,2.836-9.935,4.776-14.612 c2.216-5.264,3.959-10.72,5.38-16.242c1.437-5.523,2.437-11.135,3.181-16.757c0.769-5.623,1.206-11.267,1.434-16.897 c0.864-22.559-1.705-44.766-5.16-66.55c-3.529-21.797-8.3-43.221-13.633-64.392c-1.349-5.289-2.7-10.574-4.1-15.839l-1.056-3.945 l-0.965-3.843c-0.687-2.555-1.2-5.144-1.764-7.725c-0.595-2.577-0.97-5.186-1.469-7.783l-0.554-3.916 c-0.196-1.306-0.368-2.614-0.49-3.924c-0.668-5.241-0.831-10.506-0.876-15.767c-0.016-5.264,0.384-10.52,1.207-15.695 c0.846-5.166,2.001-10.296,3.721-15.23c0.887-2.45,1.841-4.884,2.967-7.228c1.073-2.379,2.324-4.661,3.677-6.876 c2.721-4.395,5.944-8.589,9.769-11.907L278.446,206.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M429.496,536.103c-2.116,17.2-5.124,34.254-8.799,51.075 c-1.849,8.41-3.884,16.764-6.138,25.038c-0.534,2.078-1.168,4.123-1.748,6.185c-0.574,2.065-1.206,4.108-1.833,6.152 c-1.198,4.11-2.553,8.158-3.872,12.219c-1.42,4.019-2.798,8.055-4.348,12.013c-1.436,4.011-3.082,7.919-4.671,11.855 c-3.338,7.79-6.861,15.479-10.776,22.939c-3.9,7.468-8.214,14.663-12.804,21.672c-4.684,6.933-9.784,13.525-15.184,19.922 l0.764,0.909c6.251-5.497,12.005-11.695,17.309-18.335c5.21-6.72,9.973-13.857,14.328-21.281 c4.203-7.516,8.168-15.204,11.589-23.175c1.665-4.003,3.386-7.986,4.892-12.061c1.566-4.052,2.931-8.185,4.35-12.295 c1.314-4.15,2.662-8.286,3.849-12.478c0.625-2.085,1.194-4.189,1.737-6.299c0.541-2.112,1.137-4.206,1.631-6.33 c2.142-8.449,3.903-17.001,5.424-25.594c2.987-17.193,5.077-34.567,5.43-52.059L429.496,536.103z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131346570947785343800000013302529673133417624_",
    gradientUnits: "userSpaceOnUse",
    x1: -1194.1263,
    y1: 695.4839,
    x2: -1016.6282,
    y2: 162.9878,
    gradientTransform: "matrix(-1 0 0 1 -500.3689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131346570947785343800000013302529673133417624_)"
    },
    d: "M235.443,714.801 c0,7.636,6.254,13.885,13.898,13.885h751.543c7.644,0,13.898-6.248,13.898-13.885l6.254-431.891 c0-7.636-8.997-22.545-25.486-21.425l-734.491-19.005c-9.591-0.248-18.864,3.443-25.655,10.213 c-6.792,6.77-10.508,16.025-10.281,25.607L235.443,714.801z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116230163817586076380000001759350303461280670_",
    gradientUnits: "userSpaceOnUse",
    x1: -798.3075,
    y1: 127.9564,
    x2: -1777.386,
    y2: 1246.2306,
    gradientTransform: "matrix(-1 0 0 1 -500.3689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116230163817586076380000001759350303461280670_)"
    },
    d: "M249.163,701.481 c0,7.231,5.917,13.148,13.149,13.148l720.448,0c7.232,0,13.148-5.917,13.148-13.148l5.901-392.075 c-0.695-23.594-21.381-32.074-33.92-31.573l-703.942-18.886c-6.738-0.181-13.253,2.415-18.025,7.175 c-4.772,4.76-7.397,11.274-7.228,18.013L249.163,701.481z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M988.123,514.29c-0.005,0-0.01,0-0.015,0c-0.552-0.008-0.993-0.462-0.985-1.015l0.467-31.797 c0.008-0.547,0.454-0.985,1-0.985c0.005,0,0.01,0,0.015,0c0.552,0.008,0.993,0.462,0.985,1.015l-0.467,31.797 C989.114,513.852,988.668,514.29,988.123,514.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M989.267,436.372c-0.005,0-0.01,0-0.015,0c-0.552-0.008-0.993-0.462-0.985-1.015l1.789-121.781 c-0.034-7.513-2.326-13.512-6.812-17.811c-8.298-7.952-21.421-7.546-21.973-7.526l-224.935-6.032 c-0.552-0.015-0.988-0.474-0.973-1.026c0.015-0.552,0.494-0.993,1.026-0.973l224.861,6.033 c0.538-0.021,14.472-0.452,23.377,8.081c4.892,4.688,7.391,11.169,7.428,19.265l-1.789,121.8 C990.258,435.934,989.812,436.372,989.267,436.372z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M964.168,679.73c-0.754-32.405-0.474-319.364,1.386-344.146 c1.859-24.783-36.739-29.432-95.998-32.22c-59.259-2.789-559.255-13.831-572.129-14.875 c-28.937-2.346-40.108,9.838-32.032,134.804c4.552,70.431,5.78,186.755,7.439,240.197c0.494,15.913,13.5,28.538,29.42,28.582 c120.319,0.331,581.468,1.652,612.167,2.567C949.749,695.69,964.467,692.58,964.168,679.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052067250946395641280000001626937684361502104_",
    gradientUnits: "userSpaceOnUse",
    x1: -781.9016,
    y1: 650.0353,
    x2: -1570.4536,
    y2: 841.8452,
    gradientTransform: "matrix(-1 0 0 1 -500.3689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052067250946395641280000001626937684361502104_)"
    },
    d: "M181.979,750.729h871.029 c4.128,0,7.505-3.377,7.505-7.505v-22.937c0-4.128-3.377-7.505-7.505-7.505H181.979c-4.128,0-7.505,3.377-7.505,7.505v22.937 C174.474,747.352,177.852,750.729,181.979,750.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M871.107,374.706H302.551c-4.971,0-9-4.029-9-9v-30.961c0-4.971,4.029-9,9-9h568.557 c4.971,0,9,4.029,9,9v30.961C880.107,370.677,876.078,374.706,871.107,374.706z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131326724539093243560000015190061502876648622_",
    gradientUnits: "userSpaceOnUse",
    x1: 613.4064,
    y1: 637.8489,
    x2: 572.266,
    y2: 870.3396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "url(#SVGID_00000131326724539093243560000015190061502876648622_)"
    },
    d: "M918.548,671.412H305.051 c-6.351,0-11.5-5.149-11.5-11.5v-25.961c0-6.351,5.149-11.5,11.5-11.5h613.497c6.351,0,11.5,5.149,11.5,11.5v25.961 C930.048,666.263,924.899,671.412,918.548,671.412z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.339,
    y: 551.946,
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    width: 343.708,
    height: 59.733
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.551,
    y: 395.27,
    style: {
      fill: "#FFFFFF"
    },
    width: 271.246,
    height: 12.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.551,
    y: 416.813,
    style: {
      fill: "#FFFFFF"
    },
    width: 271.246,
    height: 12.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.551,
    y: 438.356,
    style: {
      fill: "#FFFFFF"
    },
    width: 271.246,
    height: 12.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.551,
    y: 459.899,
    style: {
      opacity: 0.53,
      fill: "#FFFFFF"
    },
    width: 271.246,
    height: 151.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013896704197958627410000016123230948957256347_",
    gradientUnits: "userSpaceOnUse",
    x1: 686.9697,
    y1: 4.2279,
    x2: 866.5201,
    y2: 444.9438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013896704197958627410000016123230948957256347_)"
    },
    d: "M987.126,177.557 c-0.922-14.252-9.529-26.878-22.43-33.005L797.547,65.167c-10.704-5.084-23.128-5.084-33.832,0l-167.149,79.385 c-12.901,6.127-21.508,18.753-22.43,33.005C558.456,419.91,713.85,508.214,764.789,530.519c10.102,4.424,21.58,4.424,31.683,0 C847.412,508.214,1002.805,419.91,987.126,177.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M730.071,98.74c-0.936,0-1.833-0.527-2.26-1.428c-0.592-1.247-0.061-2.739,1.186-3.331 l39.495-18.757c1.249-0.593,2.739-0.062,3.331,1.186c0.592,1.247,0.062,2.739-1.186,3.331l-39.495,18.757 C730.795,98.662,730.43,98.74,730.071,98.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M586.917,229.549c-1.342,0-2.452-1.065-2.497-2.416c-0.529-15.764-0.251-32.202,0.826-48.857 c0.659-10.195,6.827-19.264,16.096-23.667l112.443-53.403c1.247-0.593,2.739-0.062,3.331,1.186 c0.592,1.248,0.062,2.739-1.185,3.331l-112.443,53.403c-7.632,3.625-12.709,11.086-13.252,19.473 c-1.067,16.493-1.342,32.766-0.818,48.366c0.046,1.38-1.035,2.536-2.414,2.583C586.973,229.548,586.945,229.549,586.917,229.549z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011751552958947495120000016673806752959549622_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.7433,
    y1: 57.3321,
    x2: 853.98,
    y2: 416.2777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011751552958947495120000016673806752959549622_)"
    },
    d: "M946.707,187.017 c-0.185-3.613-2.336-6.838-5.604-8.391l-156.256-74.212c-2.668-1.267-5.764-1.267-8.432,0l-156.256,74.212 c-3.268,1.552-5.419,4.777-5.604,8.391c-4.621,90.405,16.261,165.836,62.109,224.3c34.955,44.573,75.846,68.46,99.807,79.604 c2.64,1.228,5.678,1.228,8.318,0c23.961-11.144,64.852-35.031,99.807-79.604C930.445,352.853,951.327,277.421,946.707,187.017z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082369766883266331140000003398333523681184187_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.7121,
    y1: 172.797,
    x2: 792.5047,
    y2: 349.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082369766883266331140000003398333523681184187_)"
    },
    d: "M734.43,284.148h-15.573v-62.061 c0-24.375,18.247-44.975,42.445-47.915l31.841-3.869c13.704-1.665,27.493,2.63,37.829,11.784 c10.335,9.155,16.262,22.324,16.262,36.131v54.18H831.66v-54.18c0-9.352-4.015-18.272-11.015-24.473 c-7.001-6.201-16.341-9.111-25.623-7.982l-31.842,3.869c-16.39,1.992-28.75,15.945-28.75,32.456V284.148z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071559926085231277690000003799193424488538516_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.8228,
    y1: 260.0833,
    x2: 814.2261,
    y2: 467.6638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071559926085231277690000003799193424488538516_)"
    },
    d: "M714.253,270.214l136.514-7.563 c5.544-0.307,10.209,4.106,10.209,9.659v108.148c0,5.343-4.331,9.674-9.674,9.674H718.068c-5.22,0-9.499-4.141-9.669-9.359 l-3.28-100.585C704.948,274.935,709.004,270.505,714.253,270.214z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074406307407106875000000004519190016579580579_",
    gradientUnits: "userSpaceOnUse",
    x1: 807.5721,
    y1: 302.0236,
    x2: 760.5517,
    y2: 363.5929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074406307407106875000000004519190016579580579_)"
    },
    d: "M805.301,359.151l-8.263-23.755 c-0.993-2.856-0.317-6.049,1.807-8.202c4.234-4.29,6.757-10.273,6.459-16.844c-0.527-11.588-9.993-20.983-21.584-21.428 c-12.827-0.493-23.381,9.76-23.381,22.478c0,7.055,3.25,13.349,8.333,17.472c2.636,2.139,3.72,5.653,2.605,8.859l-7.45,21.419 c-1.812,5.209,2.056,10.649,7.571,10.649h26.333C803.245,369.8,807.113,364.36,805.301,359.151z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146489777476037599030000007054166319775274132_",
    gradientUnits: "userSpaceOnUse",
    x1: -935.2421,
    y1: 630.166,
    x2: -883.2903,
    y2: 630.166,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146489777476037599030000007054166319775274132_)"
    },
    d: "M951.601,754.645 c1.418,0,2.67-0.913,2.914-2.204l46.032-243.672c0.272-1.44-0.814-2.804-2.426-3.046c-1.612-0.241-3.138,0.727-3.411,2.167 l-46.032,243.672c-0.272,1.44,0.814,2.804,2.425,3.046C951.272,754.633,951.438,754.645,951.601,754.645z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067226769881350239330000013404286960507188873_",
    gradientUnits: "userSpaceOnUse",
    x1: -1044.5117,
    y1: 631.7502,
    x2: -984.3279,
    y2: 631.7502,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067226769881350239330000013404286960507188873_)"
    },
    d: "M1106.896,754.646 c0.194,0,0.391-0.017,0.588-0.053c1.602-0.288,2.639-1.682,2.316-3.113l-54.264-240.502c-0.323-1.431-1.881-2.365-3.486-2.069 c-1.602,0.288-2.639,1.682-2.316,3.113l54.264,240.502C1104.281,753.779,1105.516,754.646,1106.896,754.646z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152224750526576555660000008652768516556898972_",
    gradientUnits: "userSpaceOnUse",
    x1: -1003.0002,
    y1: 566.3444,
    x2: -918.4184,
    y2: 566.3444,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152224750526576555660000008652768516556898972_)"
    },
    d: "M986.725,568.988h78.663 c1.634,0,2.959-1.183,2.959-2.643c0-1.46-1.325-2.643-2.959-2.643h-78.663c-1.634,0-2.959,1.183-2.959,2.643 C983.766,567.805,985.091,568.988,986.725,568.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031202735329952563560000010373056549970258366_",
    gradientUnits: "userSpaceOnUse",
    x1: -1001.4645,
    y1: 566.3444,
    x2: -919.952,
    y2: 566.3444,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031202735329952563560000010373056549970258366_)"
    },
    d: "M988.151,568.988h75.809 c1.575,0,2.852-1.183,2.852-2.643c0-1.46-1.277-2.643-2.852-2.643h-75.809c-1.575,0-2.852,1.183-2.852,2.643 C985.299,567.805,986.576,568.988,988.151,568.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057105826252369197740000014130978320169812159_",
    gradientUnits: "userSpaceOnUse",
    x1: -1003.0002,
    y1: 610.4036,
    x2: -918.4184,
    y2: 610.4036,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057105826252369197740000014130978320169812159_)"
    },
    d: "M986.725,613.047h78.663 c1.634,0,2.959-1.183,2.959-2.644c0-1.46-1.325-2.644-2.959-2.644h-78.663c-1.634,0-2.959,1.183-2.959,2.644 C983.766,611.864,985.091,613.047,986.725,613.047z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054262078781858448550000005379387833832637613_",
    gradientUnits: "userSpaceOnUse",
    x1: -1012.5627,
    y1: 610.4036,
    x2: -911.2758,
    y2: 610.4036,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054262078781858448550000005379387833832637613_)"
    },
    d: "M979.582,613.047h95.368 c1.634,0,2.959-1.183,2.959-2.644c0-1.46-1.325-2.644-2.959-2.644h-95.368c-1.634,0-2.959,1.183-2.959,2.644 C976.623,611.864,977.948,613.047,979.582,613.047z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178914883481710866850000006168460836120333207_",
    gradientUnits: "userSpaceOnUse",
    x1: -994.9366,
    y1: 536.9617,
    x2: -924.9849,
    y2: 536.9617,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178914883481710866850000006168460836120333207_)"
    },
    d: "M993.292,539.605h64.033 c1.634,0,2.959-1.183,2.959-2.644c0-1.46-1.325-2.643-2.959-2.643h-64.033c-1.634,0-2.959,1.183-2.959,2.643 C990.332,538.422,991.657,539.605,993.292,539.605z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172432008966055003320000007147618913672325263_",
    gradientUnits: "userSpaceOnUse",
    x1: -1003.0002,
    y1: 654.4629,
    x2: -918.4184,
    y2: 654.4629,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172432008966055003320000007147618913672325263_)"
    },
    d: "M986.725,657.106h78.663 c1.634,0,2.959-1.183,2.959-2.643c0-1.46-1.325-2.643-2.959-2.643h-78.663c-1.634,0-2.959,1.183-2.959,2.643 C983.766,655.923,985.091,657.106,986.725,657.106z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000217779056620025510000016183386623464729219_",
    gradientUnits: "userSpaceOnUse",
    x1: -1022.2406,
    y1: 654.4629,
    x2: -902.1666,
    y2: 654.4629,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000217779056620025510000016183386623464729219_)"
    },
    d: "M970.473,657.106h114.155 c1.634,0,2.959-1.183,2.959-2.643c0-1.46-1.325-2.643-2.959-2.643H970.473c-1.634,0-2.959,1.183-2.959,2.643 C967.514,655.923,968.839,657.106,970.473,657.106z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051365590583723398860000006783453787390280377_",
    gradientUnits: "userSpaceOnUse",
    x1: -1031.4177,
    y1: 698.5223,
    x2: -918.4184,
    y2: 698.5223,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051365590583723398860000006783453787390280377_)"
    },
    d: "M986.725,701.166h107.081 c1.634,0,2.959-1.183,2.959-2.643c0-1.46-1.325-2.644-2.959-2.644H986.725c-1.634,0-2.959,1.183-2.959,2.644 C983.766,699.983,985.091,701.166,986.725,701.166z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149373430766090949850000017973119062775865509_",
    gradientUnits: "userSpaceOnUse",
    x1: -1031.4177,
    y1: 698.5223,
    x2: -894.7983,
    y2: 698.5223,
    gradientTransform: "matrix(-1 0 0 1 65.3473 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149373430766090949850000017973119062775865509_)"
    },
    d: "M963.105,701.166h130.701 c1.634,0,2.959-1.183,2.959-2.643c0-1.46-1.325-2.644-2.959-2.644H963.105c-1.634,0-2.959,1.183-2.959,2.644 C960.146,699.983,961.471,701.166,963.105,701.166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042713787347550351510000000739047186385104771_",
    gradientUnits: "userSpaceOnUse",
    x1: -2501.6233,
    y1: -51.23,
    x2: -2516.8013,
    y2: -0.3105,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042713787347550351510000000739047186385104771_)"
    },
    d: "M1046.148,522.9 c0,0,1.692,2.667,2.117,10.132c0.04,0.696-0.511,1.288-1.208,1.288h-13.23c-0.532,0-0.912-0.522-0.742-1.026 c0.775-2.294,3.12-7.889,8.35-11.086L1046.148,522.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137109795339350278750000003202743473327145368_",
    gradientUnits: "userSpaceOnUse",
    x1: -2681.3762,
    y1: 521.1902,
    x2: -2675.2019,
    y2: 521.1902,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137109795339350278750000003202743473327145368_)"
    },
    d: "M1046.723,517.841l-0.748,6.275 c-0.065,0.541-0.489,0.975-1.03,1.037c-0.724,0.083-1.775,0.142-2.798-0.026c-0.929-0.153-1.598-0.981-1.598-1.922v-6.058 L1046.723,517.841z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059294047048986228900000017272161300696952198_",
    gradientUnits: "userSpaceOnUse",
    x1: -2468.0703,
    y1: -41.232,
    x2: -2483.2483,
    y2: 9.6879,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059294047048986228900000017272161300696952198_)"
    },
    d: "M1013.415,522.208 c0,0,2.532,3.936,2.478,9.339c-0.013,1.273-1.078,2.286-2.351,2.286h-20.548c-0.962,0-1.353-1.236-0.565-1.789 c3.888-2.73,11.531-7.831,17.058-9.836H1013.415z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149358175184791448150000007867945526962625936_",
    gradientUnits: "userSpaceOnUse",
    x1: -2650.1833,
    y1: 518.4487,
    x2: -2644.0435,
    y2: 518.4487,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149358175184791448150000007867945526962625936_)"
    },
    d: "M1015.531,515.432l-1.596,7.749 c-0.178,0.867-1.026,1.45-1.89,1.257c-0.525-0.117-1.144-0.342-1.806-0.756c-0.629-0.393-0.948-1.142-0.819-1.872l1.651-9.388 L1015.531,515.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026146011120061555700000007556507792018938008_",
    gradientUnits: "userSpaceOnUse",
    x1: 1007.4327,
    y1: 441.4668,
    x2: 1091.1564,
    y2: 536.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026146011120061555700000007556507792018938008_)"
    },
    d: "M1043.792,407.691 c0,0,5.55,4.893,6.594,10.779c1.044,5.887-2.959,101.563-2.959,101.563s-5.549,0.923-8.41-0.81c0,0-3.393-62.093-5.972-76.442 c0,0-13.525,64.32-17.273,75.942c0,0-5.346,0.65-7.07-0.367c0,0,3.543-83.378,7.995-98.201L1043.792,407.691z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011749138344172194890000001801121607343688105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1042.1929,
    y1: 420.2712,
    x2: 1029.4629,
    y2: 448.9952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011749138344172194890000001801121607343688105_)"
    },
    d: "M1033.206,440.895 c-0.061,0-0.124-0.008-0.185-0.024c-0.393-0.102-0.628-0.503-0.526-0.895l2.357-9.043c0.046-0.179,0.159-0.333,0.314-0.433 l5.093-3.267c0.34-0.219,0.795-0.12,1.015,0.222c0.219,0.341,0.12,0.796-0.222,1.015l-4.851,3.112l-2.285,8.764 C1033.83,440.676,1033.532,440.895,1033.206,440.895z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072261056880888079650000017973064998275839149_",
    gradientUnits: "userSpaceOnUse",
    x1: -3177.3062,
    y1: -112.5126,
    x2: -3189.7981,
    y2: -43.4407,
    gradientTransform: "matrix(-0.8919 -0.4522 -0.4522 0.8919 -1866.0428 -1038.933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072261056880888079650000017973064998275839149_)"
    },
    d: "M998.08,355.382 c21.714,8.835,24.974,15.909,24.974,15.909l-18.029,10.731c0,0-20.269-10.786-29.207-29.532c4.245-1.565,7.809-3.866,10.322-5.79 C989.126,350.19,993.015,353.321,998.08,355.382z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120533118314022403080000001434170559993938311_",
    gradientUnits: "userSpaceOnUse",
    x1: -3170.5388,
    y1: -65.3149,
    x2: -3147.7195,
    y2: -65.3149,
    gradientTransform: "matrix(-0.8919 -0.4522 -0.4522 0.8919 -1866.0428 -1038.933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120533118314022403080000001434170559993938311_)"
    },
    d: "M980.958,308.251 c0.367-0.654,1.364-0.376,1.34,0.373l-0.218,7.022c-0.042,1.357-0.5,2.668-1.311,3.756l-2.607,2.829 c-1.096,1.469-1.511,3.332-1.138,5.126c0.894,4.293,3.269,12.509,9.116,19.343c-2.513,1.924-6.077,4.225-10.322,5.79 c-3.279-6.878-5.035-14.827-3.701-23.709c-1.02-0.984-1.251-2.531-0.562-3.769L980.958,308.251z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178896624555376883800000008742966787720360355_",
    gradientUnits: "userSpaceOnUse",
    x1: -2630.0972,
    y1: 332.5294,
    x2: -2642.5884,
    y2: 450.8288,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178896624555376883800000008742966787720360355_)"
    },
    d: "M981.335,362.683 c8.224-8.862,23.89-12.866,32.96-14.511c3.974-0.721,7.891,1.491,9.298,5.276c4.082,10.972,15.183,39.518,17.334,44.424 c1.765,4.025,3.609,7.956,4.78,10.414c0.7,1.468,0.088,3.225-1.377,3.931c-7.631,3.678-21.362,7.84-26.929,9.463 c-1.224,0.357-2.444-0.562-2.444-1.838c0-1.082-0.294-2.143-0.851-3.071l-21.083-35.133 c-13.141,14.57-24.648,15.902-33.488,12.713c1.487-4.594,2.459-9.196,2.926-13.807 C975.522,378.308,981.335,362.683,981.335,362.683z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080205778050703529570000011665530362879666596_",
    gradientUnits: "userSpaceOnUse",
    x1: -2557.4321,
    y1: 343.6366,
    x2: -2606.7385,
    y2: 404.9783,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080205778050703529570000011665530362879666596_)"
    },
    d: "M940.876,378.1l2.357-3.142 c7.63,5.24,14.008,6.482,19.229,5.588c-0.467,4.611-1.439,9.214-2.926,13.807C947.891,390.151,940.876,378.1,940.876,378.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081642872372588932150000010004424682545037448_",
    gradientUnits: "userSpaceOnUse",
    x1: -2548.0842,
    y1: 351.1508,
    x2: -2597.3901,
    y2: 412.4922,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081642872372588932150000010004424682545037448_)"
    },
    d: "M942.538,378.157l-13.278,0.517 l-12.225-6.828c1.755-1.1,11.678,1.148,11.678,1.148s10.374-1.569,13.182-1.573c2.332-0.003,1.999,3.35,1.819,4.487 c-0.037,0.232-0.067,0.371-0.067,0.371L942.538,378.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090291412994646009910000001659034689238534847_",
    gradientUnits: "userSpaceOnUse",
    x1: -2612.9021,
    y1: 306.5652,
    x2: -2660.6553,
    y2: 394.3069,
    gradientTransform: "matrix(-1 0 0 1 -1634.6527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090291412994646009910000001659034689238534847_)"
    },
    d: "M1001.82,331.897l7.006,17.096 c0,0-8.05,5.572-14.526,5.041l-3.497-15.372L1001.82,331.897z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044883271040813804120000014514770036002373266_",
    gradientUnits: "userSpaceOnUse",
    x1: -2572.4968,
    y1: 1539.401,
    x2: -2593.6011,
    y2: 1567.3202,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 -220.6582 -2418.519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044883271040813804120000014514770036002373266_)"
    },
    d: "M989.986,320.242 c-0.161,0.227-5.068,17.957-5.068,17.957l10.183,2.587l7.148-16.113C1002.249,324.673,992.672,316.437,989.986,320.242z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028321359536097732450000018123506393607838873_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.4337,
    y1: 297.4157,
    x2: 360.7897,
    y2: 384.5854,
    gradientTransform: "matrix(1 0 0 1 635.9356 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028321359536097732450000018123506393607838873_)"
    },
    d: "M998.414,327.122l-3.099,8.777 c-0.04,0.113-0.093,0.217-0.162,0.314c-0.42,0.598-2.018,2.547-3.913,0.791c-1.719-1.593-3.312-3.022-4.783-3.281 c-0.66-0.116-1.3,0.286-1.479,0.933c-0.445,1.611-1.382,5.26-1.712,8.554c-0.067,0.669,0.395,1.273,1.055,1.398 c1.989,0.378,6.206,1.057,9.726,0.809c0.477-0.034,0.897-0.32,1.096-0.755c0.97-2.12,3.943-8.552,5.048-10.217 c1.038-1.562,3.582-1.518,4.648-1.424c0.35,0.031,0.694-0.082,0.958-0.313c0.933-0.818,2.71-2.907,0.211-5.407 c-0.523-0.523-0.509-1.368,0.03-1.874c1.073-1.009,2.221-2.798,0.433-5.018c-1.817-2.256-4.216-1.897-5.686-1.361 c-0.594,0.217-1.243-0.034-1.566-0.578c-0.184-0.31-0.505-0.544-1.061-0.496c-0.75,0.064-1.38-0.561-1.366-1.313 c0.026-1.445-0.492-3.271-2.998-4.051c-4.448-1.385-7.222,2.913-7.497,6.12c-0.275,3.207,4.633,4.434,7.52,4.217 c2.194-0.164,3.824,2.011,4.479,3.063C998.503,326.343,998.545,326.751,998.414,327.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004511594359294860120000008917709798077086353_",
    gradientUnits: "userSpaceOnUse",
    x1: -2603.4065,
    y1: 1561.5109,
    x2: -2586.4788,
    y2: 1544.1437,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 -220.6582 -2418.519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004511594359294860120000008917709798077086353_)"
    },
    d: "M999.031,337.629 c0,0,0.719-5.567,3.034-5.84c2.316-0.273,4.57,1.631,2.268,4.755C1001.469,340.432,999.031,337.629,999.031,337.629z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040542735018092421530000001179439416760879002_",
    gradientUnits: "userSpaceOnUse",
    x1: -2780.9155,
    y1: 745.8392,
    x2: -2765.5627,
    y2: 649.2665,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040542735018092421530000001179439416760879002_)"
    },
    points: "167.819,749.368  174.922,749.368 174.922,672.551 167.819,672.551  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170240187139568111590000014755871795405800892_",
    gradientUnits: "userSpaceOnUse",
    x1: -2774.759,
    y1: 746.8179,
    x2: -2759.4063,
    y2: 650.2438,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170240187139568111590000014755871795405800892_)"
    },
    d: "M140.264,750.849h62.214l0,0 c0-2.554-2.07-4.624-4.624-4.624h-52.966C142.334,746.225,140.264,748.295,140.264,750.849L140.264,750.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080890862432779592710000006370256098285489816_",
    gradientUnits: "userSpaceOnUse",
    x1: -2786.6208,
    y1: 744.9324,
    x2: -2771.2683,
    y2: 648.3596,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080890862432779592710000006370256098285489816_)"
    },
    d: "M131.03,669.885 c0,4.201,3.438,7.639,7.639,7.639h62.944c4.202,0,7.639-3.437,7.639-7.639v-6.907c0-4.201-3.437-7.639-7.639-7.639h-62.944 c-4.201,0-7.639,3.437-7.639,7.639V669.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120519410287718077080000015202901087763995814_",
    gradientUnits: "userSpaceOnUse",
    x1: -2852.8887,
    y1: 684.3513,
    x2: -2802.3826,
    y2: 684.3513,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120519410287718077080000015202901087763995814_)"
    },
    d: "M223.81,621.332 c0,0,10.555,1.636,22.422,9.569c1.868,1.248,2.892,3.425,2.611,5.654c-1.421,11.256-7.264,47.688-26.53,83.271 c-1.016,1.876-1.308,4.06-0.86,6.147l3.347,15.577l6.207,5.82h-15.989l-10.646-28.809l4.552-1.439 c3.529-1.116,5.951-4.362,6.015-8.064l0.534-30.904c-0.456-13.768,8.442-23.268,8.442-23.268l-25.535-1.242L223.81,621.332z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142147749881556453970000016237381287199727807_",
    gradientUnits: "userSpaceOnUse",
    x1: -2821.9861,
    y1: 717.2612,
    x2: -2829.4146,
    y2: 831.1671,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142147749881556453970000016237381287199727807_)"
    },
    d: "M237.251,750.181 c1.456,1.906-15.672,4.42-24.325,0.252c0,0-11.996-20.871-11.996-31.617c0,0,0.952-2.191,7.996-1.694 c0,0,4.028,24.712,8.281,27.48c4.253,2.768,11.899,0.28,11.899,0.28S235.102,747.369,237.251,750.181z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018933860423640039610000014167208059548608951_",
    gradientUnits: "userSpaceOnUse",
    x1: -2912.1914,
    y1: 687.8013,
    x2: -2805.6133,
    y2: 687.8013,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018933860423640039610000014167208059548608951_)"
    },
    d: "M201.613,655.339 c0.136-0.235,27.492-3.289,27.492-3.289s-0.895,8.318,1.903,19.768c2.798,11.45,42.962,61.057,42.962,61.057l-4.211,13.35 c13.021,4.536,25.829,5.261,38.433,2.312l-26.099-15.662c0,0-24.426-83.239-39.388-98.089l-27.421-9.487L201.613,655.339z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009548222845635361730000010159207521340258485_",
    gradientUnits: "userSpaceOnUse",
    x1: -2846.429,
    y1: 632.2032,
    x2: -2727.0308,
    y2: 632.2032,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6645,
    style: {
      stopColor: "#E57A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009548222845635361730000010159207521340258485_)"
    },
    d: "M140.264,606.905 c0,0-15.761,23.443-17.054,34.136c-1.293,10.693,4.317,15.039,20.855,15.755c16.537,0.717,60.685,0.705,60.685,0.705 l37.68-32.202c0,0-27.459-9.798-34.599-12.569C200.691,609.96,140.264,606.905,140.264,606.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093861545936003802050000006193621539650482858_",
    gradientUnits: "userSpaceOnUse",
    x1: -2893.6716,
    y1: 712.5859,
    x2: -2901.1003,
    y2: 826.4925,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093861545936003802050000006193621539650482858_)"
    },
    d: "M271.35,741.729 c0,0-4.534,4.391-1.471,9.278c0,0,35.917,6.366,45.669,3.478c0,0-2.025-4.622-13.006-9.882l0.81,0.622 c1.025,0.787,0.424,2.427-0.866,2.353C295.25,747.165,280.275,745.839,271.35,741.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072249652638597031610000012428521266860251787_",
    gradientUnits: "userSpaceOnUse",
    x1: 3208.6875,
    y1: 451.4535,
    x2: 3079.3665,
    y2: 606.3986,
    gradientTransform: "matrix(1 0 0 1 -2972.8965 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072249652638597031610000012428521266860251787_)"
    },
    d: "M211.767,495.831 c0,2.186-19.673,83.063-19.673,83.063l-56.049,16.485c-10.809,3.179-22.414-1.208-28.417-10.742h0 c-14.915-23.69-7.79-54.986,15.91-69.883l7.938-4.989c16.923-10.637,31.533-24.571,42.959-40.971l2.99-4.291L211.767,495.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.298,573.995c-0.044,0-0.088-0.012-0.129-0.036c-6.841-4.111-7.497-13.362-7.462-17.149 c0.068-7.429,2.043-14.772,5.711-21.236c6.576-11.587,17.908-19.437,28.868-27.027l2.258-1.566 c11.097-7.72,23.352-17.089,28.321-30.609c0.048-0.129,0.192-0.193,0.321-0.148c0.129,0.048,0.196,0.191,0.149,0.321 c-5.02,13.657-17.346,23.083-28.506,30.847l-2.259,1.567c-10.914,7.558-22.198,15.374-28.718,26.863 c-3.625,6.39-5.578,13.649-5.645,20.994c-0.035,3.701,0.6,12.737,7.22,16.715c0.118,0.071,0.157,0.225,0.085,0.343 C116.465,573.952,116.382,573.995,116.298,573.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.844,561.965c-0.117,0-0.221-0.082-0.245-0.202c-1.491-7.582-1.266-14.361,0.669-20.146 c3.497-10.458,12.742-18.041,20.405-23.479c1.532-1.087,3.085-2.156,4.642-3.227c7.025-4.834,14.29-9.833,19.541-16.619 c0.085-0.11,0.243-0.128,0.351-0.045c0.109,0.084,0.129,0.242,0.045,0.351c-5.299,6.848-12.596,11.869-19.653,16.725 c-1.554,1.069-3.106,2.137-4.636,3.223c-7.601,5.394-16.768,12.909-20.219,23.229c-1.907,5.703-2.127,12.396-0.653,19.892 c0.027,0.136-0.062,0.267-0.197,0.294C120.876,561.963,120.86,561.965,120.844,561.965z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006671125515808690340000001933375185080495536_",
    gradientUnits: "userSpaceOnUse",
    x1: -2793.8464,
    y1: 533.3397,
    x2: -2737.2148,
    y2: 656.5966,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006671125515808690340000001933375185080495536_)"
    },
    d: "M182.887,603.802 c0,0,18.354-17.477,27.388-29.052c4.884-6.257,6.417-14.494,4.159-22.104c-4.125-13.896-11.455-28.289-12.123-30.529 c-1.025-3.434-21.604-3.291-21.604-3.291s-40.496,26.282-56.407,70.803l17.869,5.563c0,0,10.574-17.739,21.021-29.017 c0,0-18.077,23.881-18.714,33.657L182.887,603.802z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145773206401742091020000017007717168164731545_",
    gradientUnits: "userSpaceOnUse",
    x1: -2792.5461,
    y1: 548.5138,
    x2: -2799.7405,
    y2: 502.3504,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145773206401742091020000017007717168164731545_)"
    },
    d: "M207.842,498.213 c-0.215,0.714-8.628,23.235-9.048,23.604c-0.42,0.37-11.78,0.981-17.126-2.674l13.263-25.942L207.842,498.213z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165222876237020940530000004075202739034280586_",
    gradientUnits: "userSpaceOnUse",
    x1: -2761.8774,
    y1: 600.7535,
    x2: -2661.76,
    y2: 600.7535,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165222876237020940530000004075202739034280586_)"
    },
    d: "M220.278,605.099l-13.485-12.998 l-18.655,7.881c0,0-18.568,2.877-29.196,0c-10.627-2.877-10.627-2.877-10.627-2.877l-24.016-7.477l-3.772,10.66 c-0.958,2.706,0.005,5.711,2.345,7.374c2.077,1.476,4.513,3.099,6.065,3.778c3.163,1.384,77.963-0.957,77.963-0.957 L220.278,605.099z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133517291822609407200000011671142604043606206_",
    gradientUnits: "userSpaceOnUse",
    x1: -4356.6821,
    y1: -249.0084,
    x2: -4308.1982,
    y2: -216.0759,
    gradientTransform: "matrix(-0.9984 -0.0567 -0.0567 0.9984 -4142.8643 475.3153)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133517291822609407200000011671142604043606206_)"
    },
    d: "M205.658,460.965 c0,0,9.729,4.775,15.689,19.564c5.96,14.789,0.521,21.152-5.889,21.704c-6.41,0.552-15.909-0.127-25.438-10.003 C180.492,482.355,192.984,455.24,205.658,460.965z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036973252944496709840000017968023779742477217_",
    gradientUnits: "userSpaceOnUse",
    x1: 3728.9812,
    y1: -287.9886,
    x2: 3597.4927,
    y2: -130.4465,
    gradientTransform: "matrix(0.9984 0.0567 -0.0567 0.9984 -3514.8694 511.0581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036973252944496709840000017968023779742477217_)"
    },
    d: "M197.217,484.924 c0,0-6.324-21.501,12.374-20.689l4.222,3.322c0,0,7.519-11.295-3.416-17.511c-10.935-6.216-28.006-2.204-33.655,12.683 c-5.649,14.887-3.402,24.835,4.152,32.54c7.554,7.705,11.304-0.332,11.304-0.332s-3.953-7.03-1.981-10.559 c1.972-3.529,5.797,1.082,5.797,1.082L197.217,484.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021834386785321681370000008223519548316249225_",
    gradientUnits: "userSpaceOnUse",
    x1: -4112.2461,
    y1: 1743.1115,
    x2: -4058.7556,
    y2: 1779.4445,
    gradientTransform: "matrix(-0.914 0.4056 0.4056 0.914 -4254.5635 534.1294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021834386785321681370000008223519548316249225_)"
    },
    d: "M197.151,488.684 c0,0-8.706-9.26-11.891-2.62c-3.185,6.64,8.658,8.28,13.122,8.533L197.151,488.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030445341210552218620000007285515232499358128_",
    gradientUnits: "userSpaceOnUse",
    x1: -2820.449,
    y1: 570.5735,
    x2: -2883.4736,
    y2: 587.847,
    gradientTransform: "matrix(-0.9988 -0.0494 -0.0494 0.9988 -2632.9021 -118.7758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030445341210552218620000007285515232499358128_)"
    },
    d: "M169.247,611.227 c0.06,0.003,0.12,0.005,0.18,0.004l78.223-0.085c1.934-0.002,3.5-1.571,3.498-3.505c-0.002-1.934-1.577-3.532-3.505-3.498 l-78.223,0.085c-1.934,0.002-3.5,1.571-3.498,3.505C165.924,609.607,167.397,611.136,169.247,611.227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027563756053612851050000016444328580116108473_",
    gradientUnits: "userSpaceOnUse",
    x1: -2845.2771,
    y1: 549.7287,
    x2: -2889.9958,
    y2: 596.9938,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027563756053612851050000016444328580116108473_)"
    },
    d: "M317.969,540.205h-65.145 c-4.806,0-9.18,2.773-11.23,7.12l-30.116,63.86h80.957c3.097,0,5.879-1.892,7.018-4.772l23.354-59.093 C324.157,543.906,321.641,540.205,317.969,540.205z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090291211046867343350000013669609024418659224_",
    gradientUnits: "userSpaceOnUse",
    x1: -2872.3115,
    y1: 561.4974,
    x2: -2892.6021,
    y2: 592.0527,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090291211046867343350000013669609024418659224_)"
    },
    d: "M272.074,572.948 c-1.412,4.386-0.369,8.645,2.329,9.514c2.698,0.868,6.03-1.983,7.442-6.369c1.412-4.386,0.369-8.645-2.329-9.514 C276.818,565.711,273.486,568.562,272.074,572.948z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027587971642848073480000007517891401744632202_",
    gradientUnits: "userSpaceOnUse",
    x1: -2918.3518,
    y1: 686.7817,
    x2: -2860.1284,
    y2: 686.7817,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027587971642848073480000007517891401744632202_)"
    },
    d: "M311.818,756.982 c0.334,0,0.674-0.073,1-0.226c1.286-0.604,1.88-2.231,1.327-3.634l-53.153-134.867c-0.553-1.403-2.043-2.051-3.33-1.448 c-1.286,0.604-1.88,2.231-1.327,3.634l53.153,134.867C309.901,756.355,310.836,756.982,311.818,756.982z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118396783084359665630000013024704642059447694_",
    gradientUnits: "userSpaceOnUse",
    x1: -2911.6279,
    y1: 686.7814,
    x2: -2853.4045,
    y2: 686.7814,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118396783084359665630000013024704642059447694_)"
    },
    d: "M251.938,756.982 c0.982,0,1.917-0.627,2.329-1.674l53.153-134.867c0.553-1.403-0.041-3.03-1.327-3.634c-1.285-0.604-2.776,0.044-3.33,1.448 l-53.153,134.867c-0.553,1.403,0.041,3.03,1.327,3.634C251.264,756.909,251.604,756.982,251.938,756.982z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132788655527339761630000013194852304906768780_",
    gradientUnits: "userSpaceOnUse",
    x1: -2761.4004,
    y1: 686.7817,
    x2: -2703.177,
    y2: 686.7817,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132788655527339761630000013194852304906768780_)"
    },
    d: "M154.867,756.982 c0.334,0,0.674-0.073,1-0.226c1.286-0.604,1.88-2.231,1.326-3.634L104.04,618.255c-0.553-1.403-2.042-2.051-3.33-1.448 c-1.286,0.604-1.88,2.231-1.326,3.634l53.153,134.867C152.95,756.355,153.884,756.982,154.867,756.982z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097483215773992913910000007454700834461102725_",
    gradientUnits: "userSpaceOnUse",
    x1: -2754.6772,
    y1: 686.7814,
    x2: -2696.4536,
    y2: 686.7814,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097483215773992913910000007454700834461102725_)"
    },
    d: "M94.988,756.982 c0.982,0,1.917-0.627,2.329-1.674l53.153-134.867c0.553-1.403-0.041-3.03-1.326-3.634c-1.285-0.604-2.776,0.044-3.33,1.448 L92.661,753.122c-0.553,1.403,0.041,3.03,1.326,3.634C94.313,756.909,94.653,756.982,94.988,756.982z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087389760875138084400000003139419451854559108_",
    gradientUnits: "userSpaceOnUse",
    x1: -3029.9041,
    y1: 614.8912,
    x2: -2777.1057,
    y2: 614.8912,
    gradientTransform: "matrix(-1 0 0 1 -2604 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087389760875138084400000003139419451854559108_)"
    },
    d: "M173.165,611.084 c-0.185-0.887,0.067-1.804,0.686-2.501c0.619-0.697,1.542-1.1,2.515-1.1h245.786c1.28,0,2.471,0.605,3.161,1.606 c0.69,1.001,0.782,2.259,0.245,3.337l-3.572,7.176c-0.818,1.644-2.591,2.696-4.541,2.696H178.628c-1.814,0-3.374-1.194-3.718-2.848 L173.165,611.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M436.743,157.262c-7.465-10.682-18.606-15.079-29.522-11.881 c-11.897,3.486-18.622,16.806-29.693,22.132c-19.319,9.294-46.034-9.069-60.706,14.889c-17.945,29.303-31.811,7.326-31.811,27.21 s123.981,5.233,185.156,6.279c8.838,0.151,47.209-0.603,30.692-22.095c-5.13-6.674-12.448-7.792-19.271-9.354 c-8.896-2.036-30.048-3.154-36.49-11.261c-3.468-4.364-4.802-10.634-7.935-15.305C437.025,157.67,436.885,157.465,436.743,157.262z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M176.379,221.025c-4.643-6.643-11.572-9.378-18.361-7.389 c-7.399,2.168-11.581,10.452-18.467,13.765c-12.015,5.78-28.63-5.64-37.755,9.26c-11.16,18.224-19.784,4.556-19.784,16.923 c0,12.367,77.108,3.254,115.155,3.905c5.497,0.094,29.361-0.375,19.088-13.742c-3.19-4.151-7.742-4.846-11.985-5.817 c-5.533-1.267-18.688-1.962-22.695-7.004c-2.157-2.714-2.986-6.614-4.935-9.519C176.554,221.279,176.467,221.151,176.379,221.025z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.039,527.833l2.798-1.023l0.023-0.008c0.265-0.097,0.558,0.039,0.655,0.304 c0.097,0.265-0.039,0.558-0.304,0.655l-0.003,0.001l-2.85,1.019c-0.26,0.093-0.546-0.042-0.639-0.302 c-0.092-0.259,0.041-0.543,0.299-0.637L301.039,527.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.145,523.92l2.599-1.446l0.022-0.012c0.264-0.147,0.597-0.052,0.744,0.212 c0.147,0.264,0.052,0.597-0.212,0.743l-0.003,0.002l-2.653,1.451c-0.26,0.142-0.585,0.047-0.727-0.213 c-0.141-0.259-0.047-0.582,0.21-0.725L310.145,523.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.531,518.652l2.352-1.818l0.02-0.016c0.255-0.197,0.621-0.15,0.818,0.105 c0.197,0.255,0.15,0.621-0.105,0.817l-0.003,0.003l-2.405,1.832c-0.251,0.191-0.61,0.143-0.801-0.109 c-0.19-0.25-0.143-0.607,0.105-0.799L318.531,518.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.054,512.212l2.075-2.129l0.017-0.018c0.238-0.245,0.63-0.25,0.875-0.011 c0.245,0.239,0.25,0.63,0.011,0.875l-0.003,0.003l-2.125,2.15c-0.236,0.239-0.621,0.241-0.86,0.005 c-0.238-0.235-0.241-0.617-0.008-0.856L326.054,512.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.635,504.805l1.784-2.381l0.015-0.02c0.217-0.289,0.627-0.348,0.917-0.131 c0.289,0.217,0.348,0.627,0.131,0.917l-0.003,0.004l-1.83,2.406c-0.215,0.283-0.619,0.338-0.902,0.123 c-0.282-0.214-0.337-0.616-0.126-0.898L332.635,504.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.237,496.625l1.487-2.578l0.012-0.021c0.191-0.331,0.613-0.444,0.944-0.253 s0.444,0.613,0.253,0.944l-0.003,0.004l-1.53,2.608c-0.19,0.324-0.607,0.433-0.931,0.243c-0.323-0.189-0.431-0.603-0.245-0.926 L338.237,496.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.847,487.844l1.189-2.729l0.009-0.022c0.16-0.368,0.589-0.536,0.957-0.376 c0.368,0.16,0.536,0.589,0.376,0.957l-0.002,0.005l-1.228,2.763c-0.161,0.361-0.584,0.524-0.945,0.363 c-0.36-0.16-0.523-0.58-0.366-0.94L342.847,487.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.462,478.609l0.891-2.842l0.007-0.023c0.126-0.402,0.554-0.626,0.956-0.5 c0.402,0.126,0.626,0.554,0.5,0.956l-0.002,0.005l-0.926,2.882c-0.127,0.395-0.551,0.613-0.946,0.486 c-0.393-0.126-0.611-0.547-0.487-0.941L346.462,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.08,469.042l0.588-2.917l0.005-0.025c0.087-0.432,0.508-0.712,0.941-0.625 c0.433,0.087,0.712,0.509,0.625,0.941l-0.001,0.006l-0.619,2.961c-0.089,0.426-0.507,0.699-0.933,0.61 c-0.424-0.089-0.697-0.503-0.611-0.927L349.08,469.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.682,459.259l0.279-2.961l0.003-0.026c0.043-0.459,0.451-0.796,0.91-0.753 c0.459,0.043,0.796,0.451,0.753,0.91l-0.001,0.006l-0.306,3.011c-0.046,0.453-0.45,0.783-0.903,0.737 c-0.451-0.046-0.78-0.447-0.737-0.897L350.682,459.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.241,449.368l-0.041-2.971l0-0.029c-0.007-0.481,0.378-0.876,0.859-0.883 c0.481-0.007,0.876,0.378,0.883,0.859v0.006l0.02,3.029c0.003,0.475-0.379,0.863-0.854,0.866 c-0.473,0.003-0.859-0.376-0.866-0.848L351.241,449.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.717,439.481c-0.116-0.982-0.234-1.965-0.375-2.947c-0.071-0.496,0.274-0.955,0.77-1.026 c0.496-0.071,0.955,0.274,1.026,0.77l0.001,0.007c0.135,0.999,0.249,2.003,0.36,3.007c0.054,0.492-0.301,0.935-0.793,0.989 c-0.49,0.054-0.931-0.297-0.988-0.786L350.717,439.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.142,429.698l-0.642-2.904l-0.005-0.025c-0.111-0.504,0.207-1.003,0.711-1.114 c0.504-0.111,1.003,0.207,1.114,0.711l0,0.002l0.646,2.955c0.11,0.502-0.208,0.998-0.711,1.108 c-0.502,0.11-0.998-0.208-1.108-0.711L349.142,429.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.701,420.09l-0.895-2.837l-0.007-0.023c-0.157-0.499,0.119-1.03,0.618-1.188 c0.499-0.157,1.031,0.119,1.188,0.618l0.001,0.002l0.902,2.886c0.156,0.497-0.121,1.026-0.619,1.182 c-0.497,0.156-1.026-0.121-1.182-0.619L346.701,420.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.441,410.723l-1.126-2.755l-0.009-0.021c-0.201-0.491,0.035-1.051,0.525-1.251 c0.49-0.2,1.051,0.035,1.251,0.525l0.001,0.002l1.137,2.8c0.199,0.489-0.037,1.046-0.526,1.245 c-0.489,0.198-1.046-0.037-1.245-0.526L343.441,410.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.438,401.644l-1.334-2.663l-0.009-0.019c-0.24-0.48-0.046-1.064,0.434-1.304 c0.48-0.24,1.064-0.046,1.304,0.434l0.001,0.002l1.346,2.704c0.238,0.479,0.043,1.06-0.435,1.298 c-0.479,0.238-1.06,0.043-1.298-0.435L339.438,401.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M334.771,392.881l-1.518-2.564l-0.01-0.017c-0.277-0.468-0.122-1.071,0.345-1.348 c0.468-0.277,1.071-0.122,1.348,0.345l0.001,0.002l1.532,2.602c0.275,0.467,0.119,1.067-0.348,1.342 c-0.467,0.275-1.068,0.119-1.342-0.347L334.771,392.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M329.514,384.452l-1.681-2.463l-0.01-0.015c-0.31-0.455-0.193-1.075,0.261-1.385 c0.455-0.31,1.075-0.193,1.385,0.261l0.001,0.002l1.695,2.497c0.308,0.454,0.19,1.071-0.264,1.379 c-0.454,0.308-1.071,0.19-1.379-0.264L329.514,384.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.74,376.362l-1.822-2.359l-0.01-0.013c-0.341-0.441-0.259-1.075,0.182-1.415 c0.441-0.341,1.075-0.259,1.415,0.182l0.002,0.002l1.837,2.39c0.338,0.44,0.256,1.071-0.184,1.41 c-0.44,0.338-1.071,0.256-1.41-0.184L323.74,376.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.508,368.61l-1.95-2.259l-0.01-0.012c-0.368-0.427-0.321-1.072,0.106-1.441 c0.427-0.369,1.072-0.321,1.441,0.106l0.002,0.002l1.965,2.288c0.366,0.426,0.317,1.069-0.109,1.435 c-0.426,0.366-1.069,0.317-1.435-0.109L317.508,368.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.876,361.196l-2.061-2.16l-0.01-0.011c-0.394-0.413-0.379-1.068,0.034-1.462 c0.413-0.394,1.068-0.379,1.462,0.034l0.002,0.002l2.076,2.186c0.392,0.413,0.375,1.065-0.038,1.456 c-0.413,0.392-1.065,0.375-1.456-0.038L310.876,361.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.889,354.111l-2.159-2.062l-0.01-0.01c-0.418-0.399-0.433-1.061-0.034-1.479 c0.399-0.418,1.061-0.433,1.479-0.034l0.002,0.002l2.175,2.087c0.415,0.399,0.429,1.059,0.03,1.474 c-0.399,0.415-1.059,0.429-1.474,0.03L303.889,354.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.585,347.349l-2.249-1.967l-0.01-0.009c-0.44-0.385-0.485-1.054-0.1-1.494 c0.385-0.44,1.054-0.485,1.494-0.1l0.002,0.002l2.264,1.99c0.438,0.385,0.48,1.051,0.096,1.489 c-0.385,0.438-1.051,0.48-1.489,0.096L296.585,347.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.003,340.895l-2.318-1.882l-0.008-0.007c-0.459-0.373-0.529-1.047-0.156-1.507 c0.373-0.459,1.047-0.529,1.507-0.156l0.002,0.002l2.329,1.901c0.457,0.373,0.525,1.045,0.152,1.502s-1.045,0.525-1.502,0.152 L289.003,340.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.199,334.702l-2.379-1.813l-0.007-0.005c-0.476-0.363-0.568-1.043-0.205-1.519 c0.363-0.476,1.043-0.568,1.518-0.205l0.002,0.002l2.389,1.83c0.473,0.363,0.563,1.04,0.2,1.514 c-0.363,0.473-1.04,0.563-1.514,0.2L281.199,334.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.213,328.732l-2.426-1.752l-0.006-0.004c-0.491-0.354-0.601-1.039-0.247-1.53 s1.04-0.601,1.53-0.247l0.002,0.001l2.434,1.767c0.488,0.354,0.596,1.037,0.242,1.525c-0.355,0.488-1.037,0.596-1.526,0.242 L273.213,328.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.082,322.951l-2.459-1.701l-0.005-0.003c-0.503-0.348-0.629-1.039-0.281-1.542 c0.348-0.503,1.039-0.629,1.542-0.281l0.002,0.002l2.464,1.714c0.501,0.348,0.625,1.037,0.276,1.538 c-0.348,0.501-1.037,0.625-1.538,0.276L265.082,322.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.844,317.323l-2.488-1.664c-0.516-0.342-0.656-1.038-0.314-1.553 c0.342-0.516,1.038-0.656,1.553-0.314l0.006,0.004l2.491,1.675c0.512,0.344,0.648,1.039,0.303,1.55 C258.051,317.532,257.356,317.667,256.844,317.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248.526,311.805l-2.508-1.641c-0.525-0.341-0.673-1.043-0.331-1.568 c0.341-0.524,1.043-0.673,1.568-0.331l0.005,0.003l2.508,1.65c0.521,0.343,0.666,1.043,0.323,1.564 C249.747,312.003,249.047,312.148,248.526,311.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.151,306.353l-2.519-1.629c-0.531-0.343-0.684-1.052-0.341-1.584 c0.343-0.531,1.052-0.684,1.584-0.341l0.003,0.002l2.516,1.636c0.529,0.344,0.679,1.051,0.335,1.58 C241.386,306.546,240.68,306.697,240.151,306.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.749,300.925l-2.521-1.63c-0.537-0.347-0.691-1.064-0.344-1.601 c0.347-0.537,1.064-0.691,1.601-0.344l0.003,0.002l2.516,1.635c0.535,0.347,0.687,1.062,0.34,1.597 C232.997,301.118,232.284,301.272,231.749,300.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.349,295.479l-2.515-1.643c-0.541-0.353-0.693-1.079-0.34-1.62s1.079-0.693,1.62-0.34 l0.005,0.003l2.507,1.646c0.539,0.353,0.691,1.076,0.338,1.615C224.611,295.681,223.889,295.832,223.349,295.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.981,289.977l-2.5-1.668c-0.543-0.363-0.69-1.097-0.327-1.64 c0.363-0.543,1.097-0.69,1.64-0.327l0.006,0.004l2.488,1.67c0.542,0.361,0.689,1.093,0.328,1.635 C216.256,290.191,215.523,290.337,214.981,289.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.674,284.375l-2.476-1.706c-0.544-0.375-0.68-1.119-0.306-1.662 c0.375-0.543,1.119-0.681,1.662-0.306l0.003,0.002l0.005,0.004l2.461,1.705l0.005,0.004c0.541,0.375,0.676,1.117,0.301,1.658 C207.955,284.613,207.215,284.75,206.674,284.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.459,278.621l-2.434-1.78c-0.538-0.394-0.656-1.149-0.262-1.688s1.149-0.656,1.688-0.262 l0.002,0.002l0.013,0.009l2.405,1.768l0.012,0.009c0.536,0.394,0.651,1.147,0.257,1.683 C199.746,278.899,198.994,279.015,198.459,278.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.441,272.547l-2.343-1.911c-0.522-0.426-0.6-1.194-0.174-1.717 c0.426-0.522,1.194-0.6,1.717-0.174l0.002,0.002l0.018,0.015l2.302,1.887l0.018,0.015c0.52,0.426,0.595,1.192,0.169,1.712 C191.725,272.895,190.96,272.973,190.441,272.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M182.785,265.978l-2.197-2.092c-0.493-0.469-0.512-1.249-0.043-1.742 c0.469-0.493,1.249-0.512,1.742-0.043l0.002,0.002l0.024,0.023l2.144,2.051l0.024,0.023c0.49,0.469,0.507,1.247,0.038,1.737 C184.051,266.428,183.275,266.447,182.785,265.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.699,258.749l-1.973-2.32c-0.445-0.524-0.382-1.309,0.142-1.755 c0.524-0.445,1.309-0.382,1.755,0.142l0.002,0.002l0.03,0.035l1.908,2.256l0.029,0.034c0.443,0.523,0.377,1.306-0.146,1.749 C176.923,259.335,176.142,259.272,175.699,258.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.483,250.711l-1.636-2.583c-0.371-0.587-0.197-1.363,0.389-1.734s1.363-0.197,1.734,0.389 l0.002,0.003l0.032,0.051l1.566,2.486l0.031,0.05c0.369,0.586,0.193,1.359-0.393,1.728 C170.624,251.469,169.852,251.296,169.483,250.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.544,241.784l-1.163-2.844c-0.265-0.649,0.045-1.39,0.694-1.655 c0.649-0.265,1.39,0.045,1.655,0.694l0.001,0.003l0.028,0.068l1.101,2.712l0.027,0.067c0.263,0.648-0.049,1.386-0.696,1.649 C165.544,242.741,164.807,242.432,164.544,241.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.337,232.062l-0.567-3.029c-0.13-0.696,0.328-1.365,1.024-1.496 c0.696-0.13,1.365,0.328,1.495,1.024l0.001,0.003l0.015,0.081l0.53,2.869l0.015,0.081c0.128,0.694-0.33,1.36-1.024,1.488 C162.131,233.212,161.465,232.756,161.337,232.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M160.199,221.875l0.069-3.075c0.016-0.714,0.608-1.281,1.323-1.264 c0.714,0.016,1.281,0.608,1.265,1.323l0,0.003l-0.002,0.077l-0.073,2.921l-0.002,0.077c-0.018,0.712-0.61,1.275-1.322,1.258 C160.744,223.176,160.181,222.587,160.199,221.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.114,211.688l0.636-3c0.15-0.706,0.843-1.157,1.549-1.007s1.157,0.843,1.007,1.549 l-0.001,0.003l-0.014,0.066l-0.615,2.866l-0.014,0.067c-0.151,0.703-0.844,1.151-1.547,1 C161.412,213.081,160.963,212.391,161.114,211.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.807,201.846l1.106-2.852c0.263-0.679,1.028-1.016,1.707-0.753 c0.679,0.263,1.016,1.028,0.753,1.707l-0.001,0.003l-0.021,0.055l-1.07,2.739l-0.022,0.055c-0.264,0.677-1.027,1.011-1.704,0.746 C163.878,203.283,163.543,202.523,163.807,201.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.961,192.552l1.488-2.663c0.359-0.642,1.17-0.872,1.812-0.513 c0.642,0.359,0.872,1.17,0.513,1.812l-0.002,0.003l-0.025,0.045l-1.444,2.569l-0.026,0.046c-0.359,0.639-1.169,0.866-1.808,0.507 C167.83,193.998,167.602,193.191,167.961,192.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.307,183.909l1.805-2.456c0.44-0.598,1.281-0.726,1.879-0.287 c0.598,0.44,0.727,1.281,0.287,1.879l-0.002,0.003l-0.028,0.039l-1.754,2.374l-0.029,0.039c-0.44,0.595-1.279,0.721-1.874,0.281 C172.995,185.341,172.867,184.505,173.307,183.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.652,175.982l2.078-2.229c0.511-0.548,1.369-0.578,1.917-0.067s0.578,1.369,0.067,1.917 l-0.002,0.003l-0.032,0.034l-2.02,2.156l-0.032,0.034c-0.511,0.545-1.367,0.573-1.912,0.062S179.141,176.527,179.652,175.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.86,168.843l2.302-1.986c0.565-0.488,1.418-0.425,1.906,0.141 c0.488,0.565,0.425,1.418-0.141,1.906l-0.028,0.024l-2.236,1.939l-0.03,0.026c-0.565,0.49-1.421,0.429-1.911-0.136 c-0.49-0.566-0.429-1.421,0.136-1.911L186.86,168.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.75,162.495l2.483-1.751c0.604-0.426,1.44-0.282,1.866,0.323 c0.426,0.604,0.282,1.44-0.323,1.866l-0.029,0.021l-2.415,1.712l-0.032,0.022c-0.605,0.429-1.443,0.286-1.872-0.319 c-0.429-0.605-0.286-1.443,0.319-1.872L194.75,162.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.214,156.941l2.638-1.507c0.636-0.363,1.447-0.142,1.811,0.494 c0.364,0.636,0.142,1.447-0.494,1.811l-0.03,0.017l-2.569,1.476l-0.033,0.019c-0.637,0.366-1.451,0.146-1.817-0.491 c-0.366-0.637-0.146-1.451,0.491-1.817L203.214,156.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.165,152.213l2.768-1.253c0.662-0.3,1.441-0.006,1.74,0.656c0.3,0.662,0.006,1.441-0.656,1.74 l-0.031,0.014l-2.697,1.229l-0.034,0.015c-0.663,0.302-1.445,0.01-1.747-0.653c-0.302-0.663-0.01-1.445,0.653-1.747 L212.165,152.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.518,148.34l2.872-0.99c0.68-0.235,1.422,0.127,1.657,0.807 c0.234,0.68-0.127,1.422-0.807,1.656l-0.031,0.011l-2.801,0.973l-0.035,0.012c-0.682,0.237-1.426-0.124-1.663-0.805 s0.124-1.426,0.805-1.663L221.518,148.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.189,145.355l2.952-0.718c0.693-0.168,1.391,0.257,1.559,0.949 c0.169,0.693-0.257,1.391-0.949,1.559l-0.032,0.008l-2.879,0.707l-0.035,0.009c-0.694,0.171-1.396-0.254-1.566-0.948 c-0.171-0.694,0.254-1.395,0.948-1.566L231.189,145.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.097,143.29l3.005-0.435c0.699-0.101,1.348,0.383,1.449,1.082 c0.101,0.699-0.383,1.348-1.082,1.449l-0.033,0.005l-2.932,0.432l-0.036,0.005c-0.701,0.103-1.353-0.381-1.456-1.082 c-0.103-0.701,0.381-1.352,1.082-1.456L241.097,143.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.154,142.177l3.033-0.143c0.699-0.033,1.292,0.507,1.325,1.205 c0.033,0.699-0.507,1.292-1.205,1.325l-0.034,0.002l-2.958,0.147l-0.037,0.002c-0.701,0.035-1.297-0.505-1.332-1.206 c-0.035-0.701,0.505-1.297,1.206-1.332L251.154,142.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.275,142.049c1.012,0.035,2.02,0.104,3.03,0.156c0.692,0.036,1.224,0.626,1.188,1.318 s-0.626,1.224-1.318,1.188l-0.031-0.002c-0.986-0.049-1.973-0.114-2.958-0.146c-0.695-0.022-1.24-0.603-1.218-1.298 c0.022-0.695,0.603-1.24,1.298-1.218l0.003,0L261.275,142.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M271.352,142.902l3.002,0.439c0.679,0.099,1.149,0.73,1.05,1.409 c-0.099,0.679-0.73,1.149-1.409,1.05l-0.031-0.004l-2.935-0.422l-0.034-0.005c-0.681-0.098-1.154-0.73-1.056-1.411 c0.098-0.681,0.73-1.154,1.411-1.056L271.352,142.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.301,144.684l2.947,0.709c0.661,0.159,1.068,0.823,0.909,1.484 c-0.159,0.661-0.823,1.067-1.484,0.909l-0.029-0.007l-2.885-0.687l-0.032-0.008c-0.663-0.158-1.073-0.823-0.915-1.486 c0.158-0.663,0.823-1.073,1.486-0.915L281.301,144.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.047,147.347l2.872,0.96c0.638,0.213,0.983,0.904,0.769,1.542 c-0.213,0.638-0.904,0.983-1.542,0.769l-0.026-0.009l-2.816-0.934l-0.029-0.01c-0.641-0.212-0.988-0.904-0.775-1.545 c0.212-0.641,0.904-0.988,1.545-0.775L291.047,147.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.525,150.822l2.783,1.188c0.613,0.262,0.897,0.97,0.636,1.583 c-0.262,0.613-0.971,0.897-1.583,0.636l-0.023-0.01l-2.734-1.16l-0.026-0.011c-0.615-0.261-0.902-0.971-0.641-1.587 c0.261-0.615,0.971-0.902,1.586-0.641L300.525,150.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.689,155.027l2.685,1.392c0.586,0.304,0.814,1.024,0.51,1.61 c-0.304,0.585-1.024,0.814-1.61,0.51l-0.02-0.01l-2.642-1.362l-0.023-0.012c-0.588-0.303-0.819-1.026-0.516-1.614 c0.303-0.588,1.026-0.819,1.614-0.516L309.689,155.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.518,159.882l2.582,1.571c0.558,0.339,0.735,1.067,0.395,1.625 c-0.34,0.558-1.067,0.735-1.625,0.395l-0.017-0.01l-2.546-1.541l-0.02-0.012c-0.56-0.339-0.74-1.068-0.4-1.629 c0.339-0.56,1.068-0.74,1.629-0.4L318.518,159.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.002,165.308l2.477,1.728c0.53,0.37,0.66,1.099,0.29,1.629c-0.37,0.53-1.099,0.66-1.629,0.29 l-0.015-0.01l-2.447-1.698l-0.017-0.012c-0.533-0.37-0.665-1.101-0.295-1.634c0.37-0.533,1.101-0.665,1.634-0.295L327.002,165.308 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.139,171.231l2.374,1.864c0.503,0.395,0.591,1.123,0.196,1.626 c-0.395,0.503-1.123,0.591-1.626,0.196l-0.012-0.01l-2.349-1.835l-0.015-0.012c-0.505-0.395-0.595-1.125-0.2-1.631 c0.395-0.506,1.125-0.595,1.631-0.2L335.139,171.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.935,177.589l2.274,1.983c0.477,0.416,0.526,1.14,0.11,1.617 c-0.416,0.477-1.14,0.526-1.617,0.11l-0.011-0.009l-2.253-1.955l-0.013-0.011c-0.479-0.416-0.531-1.142-0.115-1.622 c0.416-0.48,1.142-0.531,1.622-0.115L342.935,177.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.396,184.32l2.18,2.09c0.452,0.433,0.467,1.151,0.034,1.603s-1.151,0.467-1.603,0.034 l-0.009-0.009l-2.163-2.063l-0.011-0.011c-0.455-0.434-0.472-1.154-0.038-1.608c0.434-0.455,1.154-0.472,1.608-0.038 L350.396,184.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M357.547,191.387l2.084,2.177c0.428,0.448,0.413,1.158-0.035,1.586 c-0.448,0.428-1.158,0.413-1.586-0.035l-0.008-0.008l-2.07-2.152l-0.01-0.01c-0.431-0.448-0.417-1.16,0.031-1.591 c0.448-0.431,1.161-0.417,1.591,0.031L357.547,191.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.389,198.74l1.995,2.257c0.406,0.459,0.363,1.161-0.096,1.566 c-0.459,0.406-1.161,0.363-1.567-0.096l-0.007-0.007l-1.984-2.233l-0.008-0.01c-0.409-0.46-0.367-1.163,0.093-1.572 c0.46-0.408,1.164-0.367,1.572,0.093L364.389,198.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.941,206.349l1.911,2.328c0.385,0.469,0.316,1.16-0.152,1.545 c-0.469,0.385-1.16,0.316-1.545-0.152l-0.006-0.007l-1.902-2.305l-0.007-0.009c-0.387-0.469-0.32-1.163,0.149-1.55 c0.469-0.387,1.163-0.32,1.551,0.149L370.941,206.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M377.214,214.185l1.829,2.391c0.364,0.476,0.274,1.158-0.203,1.522 c-0.476,0.364-1.158,0.274-1.522-0.203l-0.005-0.006l-1.822-2.37l-0.007-0.008c-0.367-0.477-0.277-1.161,0.2-1.528 s1.161-0.277,1.527,0.2L377.214,214.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M383.221,222.224l1.751,2.449c0.345,0.482,0.234,1.153-0.249,1.498 c-0.482,0.345-1.153,0.234-1.498-0.249l-0.004-0.006l-1.746-2.428l-0.006-0.008c-0.347-0.483-0.237-1.156,0.246-1.503 c0.483-0.347,1.156-0.237,1.503,0.246L383.221,222.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.985,230.432l1.697,2.484c0.331,0.484,0.207,1.145-0.277,1.475 c-0.484,0.331-1.146,0.205-1.477-0.279l-1.698-2.472l-0.003-0.004c-0.333-0.485-0.21-1.148,0.275-1.481 c0.485-0.333,1.148-0.21,1.481,0.275L388.985,230.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.6,238.726l1.668,2.495c0.322,0.482,0.193,1.134-0.289,1.456 c-0.482,0.322-1.133,0.193-1.455-0.288l-1.672-2.489c-0.325-0.482-0.198-1.137,0.284-1.462s1.137-0.198,1.462,0.284L394.6,238.726 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M400.151,247.046l1.666,2.493c0.319,0.476,0.192,1.12-0.284,1.439 c-0.476,0.319-1.12,0.193-1.439-0.283l-1.673-2.492c-0.321-0.477-0.193-1.124,0.284-1.445c0.477-0.32,1.124-0.193,1.444,0.284 L400.151,247.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M405.722,255.34l1.688,2.475c0.321,0.466,0.204,1.105-0.263,1.426 c-0.466,0.321-1.106,0.202-1.427-0.265l-1.699-2.478c-0.321-0.469-0.202-1.109,0.267-1.43c0.469-0.321,1.109-0.202,1.43,0.267 L405.722,255.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M411.397,263.551l1.737,2.441l0.005,0.006c0.324,0.456,0.218,1.089-0.238,1.413 c-0.456,0.324-1.087,0.22-1.411-0.236l-1.751-2.45c-0.327-0.457-0.221-1.092,0.236-1.418c0.457-0.327,1.092-0.221,1.419,0.236 l0.001,0.002L411.397,263.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M417.26,271.626l1.805,2.383l0.006,0.008c0.334,0.441,0.247,1.069-0.193,1.403 s-1.067,0.249-1.401-0.192l-1.824-2.396c-0.336-0.441-0.251-1.072,0.191-1.408c0.441-0.336,1.072-0.251,1.408,0.191l0.001,0.002 L417.26,271.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M423.378,279.484l1.896,2.305l0.009,0.01c0.347,0.422,0.286,1.045-0.136,1.392 c-0.422,0.347-1.043,0.288-1.391-0.134l-1.919-2.321c-0.349-0.423-0.29-1.048,0.133-1.397c0.423-0.349,1.048-0.29,1.398,0.133 l0.001,0.002L423.378,279.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M429.825,287.058l2.008,2.206l0.011,0.012c0.363,0.399,0.334,1.017-0.065,1.38 c-0.399,0.363-1.015,0.336-1.379-0.063l-2.035-2.225c-0.366-0.4-0.338-1.02,0.062-1.385c0.4-0.366,1.02-0.338,1.385,0.062 l0.002,0.002L429.825,287.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M436.671,294.262l2.144,2.07l0.014,0.014c0.383,0.37,0.394,0.981,0.024,1.364 s-0.979,0.396-1.363,0.025l-2.177-2.093c-0.386-0.371-0.398-0.984-0.027-1.369c0.371-0.386,0.984-0.398,1.369-0.027l0.002,0.002 L436.671,294.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M443.981,300.983l2.285,1.911l0.016,0.014c0.404,0.338,0.457,0.939,0.119,1.342 c-0.338,0.404-0.937,0.458-1.34,0.121l-2.322-1.933c-0.406-0.338-0.461-0.941-0.123-1.347c0.338-0.406,0.941-0.461,1.347-0.123 l0.002,0.001L443.981,300.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M451.761,307.147l2.425,1.727l0.019,0.013c0.423,0.301,0.522,0.889,0.221,1.312 c-0.301,0.423-0.887,0.523-1.31,0.222l-2.467-1.747c-0.426-0.301-0.526-0.891-0.225-1.316c0.301-0.426,0.891-0.526,1.316-0.225 l0.002,0.001L451.761,307.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M460.008,312.658l2.562,1.511l0.022,0.013c0.44,0.26,0.587,0.827,0.327,1.268 c-0.26,0.44-0.824,0.589-1.265,0.329l-2.613-1.526c-0.445-0.26-0.594-0.831-0.335-1.275c0.26-0.445,0.831-0.595,1.275-0.335 l0.003,0.002L460.008,312.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.702,317.414l2.693,1.257l0.025,0.012c0.446,0.208,0.638,0.738,0.431,1.184 c-0.207,0.444-0.734,0.637-1.178,0.433l-2.753-1.261c-0.453-0.207-0.651-0.742-0.444-1.195c0.207-0.453,0.742-0.651,1.195-0.444 l0.006,0.003L468.702,317.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M477.825,321.263l2.81,0.953l0.028,0.01c0.448,0.152,0.687,0.638,0.536,1.085 c-0.151,0.445-0.634,0.685-1.079,0.538l-2.873-0.952c-0.454-0.15-0.7-0.641-0.55-1.095c0.15-0.454,0.641-0.7,1.095-0.55 l0.006,0.002L477.825,321.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M487.317,324.044l2.906,0.603l0.031,0.006c0.444,0.092,0.729,0.526,0.637,0.97 c-0.092,0.442-0.523,0.726-0.965,0.638l-2.973-0.595c-0.45-0.09-0.742-0.528-0.652-0.978c0.09-0.45,0.528-0.742,0.978-0.652 l0.006,0.001L487.317,324.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M497.08,325.607l2.957,0.211l0.032,0.002c0.433,0.031,0.758,0.407,0.728,0.84 c-0.031,0.431-0.404,0.755-0.834,0.728l-3.023-0.195c-0.439-0.028-0.772-0.407-0.743-0.846c0.028-0.439,0.407-0.771,0.846-0.743 l0.006,0L497.08,325.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M506.946,325.784l2.951-0.262l0.037-0.003c0.413-0.037,0.777,0.268,0.814,0.681 c0.036,0.411-0.266,0.774-0.676,0.813l-3.023,0.29c-0.418,0.04-0.79-0.267-0.83-0.685c-0.04-0.418,0.267-0.79,0.685-0.83l0.005,0 L506.946,325.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M516.714,324.359l2.876-0.726l0.032-0.008c0.383-0.097,0.772,0.135,0.869,0.518 c0.096,0.381-0.134,0.769-0.514,0.868l-2.936,0.763c-0.388,0.101-0.784-0.132-0.885-0.52c-0.101-0.388,0.132-0.784,0.52-0.885 l0.005-0.001L516.714,324.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M526.152,321.428l2.733-1.158l0.029-0.012c0.346-0.147,0.745,0.015,0.892,0.361 c0.146,0.344-0.014,0.742-0.357,0.89l-2.783,1.202c-0.35,0.151-0.757-0.01-0.908-0.36c-0.151-0.35,0.01-0.757,0.36-0.908 l0.004-0.002L526.152,321.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M535.035,317.084l2.521-1.569l0.026-0.016c0.303-0.188,0.7-0.096,0.889,0.207 c0.187,0.301,0.096,0.697-0.203,0.886l-2.562,1.62c-0.306,0.194-0.711,0.102-0.905-0.204s-0.102-0.711,0.204-0.905l0.004-0.002 L535.035,317.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M543.115,311.39l2.225-1.964l0.024-0.021c0.253-0.223,0.638-0.199,0.861,0.054 c0.222,0.251,0.199,0.635-0.05,0.858l-2.259,2.023c-0.255,0.229-0.648,0.207-0.877-0.048c-0.229-0.255-0.207-0.648,0.048-0.877 l0.003-0.003L543.115,311.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M550.094,304.398l1.822-2.335l0.021-0.027c0.195-0.25,0.557-0.295,0.807-0.1 c0.249,0.195,0.294,0.554,0.102,0.804l-1.847,2.401c-0.197,0.256-0.565,0.304-0.821,0.107c-0.256-0.197-0.304-0.565-0.107-0.821 l0.003-0.003L550.094,304.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M555.598,296.212l1.303-2.662l0.016-0.032c0.131-0.268,0.454-0.379,0.722-0.248 c0.267,0.131,0.378,0.452,0.249,0.719l-1.316,2.736c-0.132,0.274-0.461,0.389-0.735,0.258c-0.274-0.132-0.389-0.461-0.258-0.735 l0.002-0.004L555.598,296.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M559.228,287.045l0.672-2.889l0.008-0.034c0.063-0.272,0.335-0.44,0.606-0.377 c0.27,0.063,0.439,0.332,0.378,0.603l-0.668,2.963c-0.063,0.278-0.339,0.452-0.616,0.39c-0.278-0.063-0.452-0.339-0.39-0.616 l0.001-0.004L559.228,287.045z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeny);
export default __webpack_public_path__ + "static/media/deny.b8af69d072d6f9abf254612aa444b61e.svg";
export { ForwardRef as ReactComponent };